import React, { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  Collapse,
  FormControlLabel,
  TextField,
  InputAdornment,
  Divider,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "./StyleSidebar.css";
import { withStyles } from '@material-ui/core/styles';
import FlashFloodMap from "../FlashFloodMap";
import Toggle from 'react-toggle';
import Switch from "react-switch";
import SearchIcon from '@material-ui/icons/Search';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import LayerRiver from '../../../river/LayerRiver';

const DownloadDocumentIcon = ({ size = 26, color = '#66788A' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31 32C28.24 32 26 34.24 26 37V88C26 90.76 28.24 93 31 93H53V87H33V38H52V56H70V62H76V54L56 32H31Z"
      fill={color}
    />
    <path
      d="M52 32V56H76L52 32Z"
      fill={color}
    />
    <path
      d="M69 64V82H61L72 93L83 82H75V64H69Z"
      fill={color}
    />
    <path
      d="M61 98H85V104H61V98Z"
      fill={color}
    />
  </svg>
);

const getFileName = (forecastChecked) => {
  const today = new Date().toISOString().split('T')[0].replace(/-/g, '');
  const dailyDates = forecastChecked
    .filter(v => v.startsWith('day_'))
    .map(v => v.replace('day_', '').replace(/-/g, ''))
    .sort();
  const ranges = forecastChecked.filter(v => v.startsWith('range_'));
  if (ranges.length === 1 && dailyDates.length === 0) {
    const days = ranges[0].replace('range_', '');
    return `flashflood_${days}d_${today}.csv`;
  }
  if (dailyDates.length === 1 && ranges.length === 0) {
    return `flashflood_daily_${dailyDates[0]}.csv`;
  }
  if (dailyDates.length > 1 && ranges.length === 0) {
    return `flashflood_daily_${dailyDates[0]}-${dailyDates[dailyDates.length - 1]}.csv`;
  }
  return `flashflood_${today}.csv`;
};

export default function FlashFloodSidebar({
  header,
  datasNhc,
  onOpenReport,
  onFcstRainToggle,
  onMainRiverToggle,
  onSecoundRiverToggle,
  onProvinceBoundaryToggle,
  onAmphoeBoundaryToggle,
  onTambonBoundaryToggle,
  onRiskAreaToggle,
  onStormToggle,
  onMockToggle,
  rainfallEnabled,
  setRainfallEnabled,
  forecastDay,
  setForecastDay,
  forecastRainEnabled,
  setForecastRainEnabled,
  forecastRainDay,
  setForecastRainDay,
  forecastOptions,
  sidebarOpen,
  setSidebarOpen,
  onRiverToggle,
  geojsonTambon,
  onStationSelect,
  ffpiEnabled,
  onFfpiToggle,
  onRiskDaysChange,
  onForecastAccumChange,
  onDownload,
  accumOptions,
  forecastAccumEnabled,
  setForecastAccumEnabled,
  forecastAccumDay,
  setForecastAccumDay,
  obsRainEnabled,
  setObsRainEnabled,
}) {
    const { t } = useTranslation();
    const [mockSwitch, setMockSwitch] = useState(false);
    const [mainRiver, setMainRiver] = useState(false);
    const [subRiver, setSubRiver] = useState(false);
    const [openRiver, setOpenRiver] = useState(false);
    const [secoundRiver, setsecoundRiver] = useState(false);
    const [provinceBoundary, setProvinceBoundary] = useState(false);
    const [amphoeBoundary, setAmphoeBoundary] = useState(false);
    const [openBoundary, setOpenBoundary] = useState(false);
    const [tambonBoundary, setTambonBoundary] = useState(false);
    const [mockSwitch1, setMockSwitch1] = useState(false);
    const [stormEnabled, setStormEnabled] = useState(false);
    const [riskAreaEnabled, setRiskAreaEnabled] = useState(true);
    const [search, setSearch] = useState('');
    const [riverEnabled, setRiverEnabled] = useState(false);
    const [forecastChecked, setForecastChecked] = useState(() => {
        const today = new Date().toISOString().split('T')[0];
        return [`day_${today}`];
    });
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const filtered = search.trim()
    ? datasNhc.filter(d =>
        (d.tumbon ?? '').includes(search) ||
        (d.amphon ?? '').includes(search) ||
        (d.provices ?? '').includes(search)
        )
    : [];

    const buildForecastOptions = () => {
    const today = new Date();
    const dailyOptions = Array.from({ length: 6 }, (_, i) => {
        const d = new Date(today);
        d.setDate(today.getDate() + i);
        const dateStr = d.toISOString().split('T')[0];
        return {
        value: `day_${dateStr}`,
        label: `พื้นที่เสี่ยงวันที่ ${dateStr}`,
        day: i + 1,
        };
    });
    return [
        ...dailyOptions,
        { value: 'range_1', label: 'พื้นที่เสี่ยง 1 วัน', day: 1 },
        { value: 'range_3', label: 'พื้นที่เสี่ยง 3 วัน', day: 3 },
        { value: 'range_6', label: 'พื้นที่เสี่ยง 6 วัน', day: 6 },
    ];
    };

    const forecastCheckOptions = buildForecastOptions();

    useEffect(() => {
    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
        }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
    <div style={{
        width: sidebarOpen ? 356 : 0,
        minWidth: sidebarOpen ? 356 : 0,
        height: '100%',
        borderTopLeftRadius: 16,
        borderBottomLeftRadius: 16,
        border: sidebarOpen ? '1px solid #BBCEDAE5' : 'none',
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.25s ease, min-width 0.25s ease',
    }}>
        <Box p={2} style={{ overflowY: 'auto', height: '100%' }}>
            <Box mt={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                        <Typography style={{ fontFamily: 'Kanit', fontWeight: 700, fontSize: 15 }}>
                            พื้นที่เสี่ยงน้ำท่วมฉับพลัน
                        </Typography>
                        <Typography style={{ fontFamily: 'Kanit', fontWeight: 400, fontSize: 9, color: '#8A99A7' }}>
                            เลือกวันแสดงผลล่วงหน้า 1–6 วัน
                        </Typography>
                        </Box>
                        <Button
                            onClick={() => setSidebarOpen(false)}
                            style={{
                            minWidth: 36,
                            width: 36,
                            height: 36,
                            padding: 6,
                            borderRadius: 8,
                            border: '1px solid #CCCCCC',
                            background: '#F7F7F7D9',
                            marginBottom: 2,
                            }}
                        >
                            <ChevronLeftIcon style={{ fontSize: 24, color: '#000000', transition: 'transform 0.25s ease',}} />
                        </Button> 
                        {/* <Switch
                            checked={riskAreaEnabled}
                            onChange={(checked) => {
                                setRiskAreaEnabled(checked);
                                if (onRiskAreaToggle) onRiskAreaToggle(checked);
                            }}
                            height={19} width={34} handleDiameter={13}
                            onColor="#2196F3" offColor="#D9D9D9"
                            checkedIcon={false} uncheckedIcon={false}
                        /> */}
                </Box>
                    <Box mt={1} display="flex" alignItems="center" style={{ gap: 8 }}>
                    {/* Dropdown */}
                    <Box ref={dropdownRef} style={{ position: 'relative', flex: 1 }}>
                        <Box
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                        style={{
                            height: 36,
                            border: '1px solid rgba(0,0,0,0.23)',
                            borderRadius: 4,
                            padding: '0 12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            backgroundColor: '#fff',
                        }}
                        >
                        <Typography style={{ fontFamily: 'Kanit', fontSize: 12, color: forecastChecked.length === 0 ? '#9e9e9e' : '#000' }}>
                            {forecastChecked.length === 0 ? 'เลือกพื้นที่เสี่ยง' : `เลือกแล้ว ${forecastChecked.length} รายการ`}
                        </Typography>
                        <KeyboardArrowDownIcon style={{ fontSize: 18, color: '#555', transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }} />
                        </Box>

                        {dropdownOpen && (
                        <Box style={{ position: 'absolute', top: 38, left: 0, right: 0, zIndex: 1300, backgroundColor: '#fff', border: '1px solid rgba(0,0,0,0.15)', borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.15)', maxHeight: 280, overflowY: 'auto' }}>
                            {forecastCheckOptions.map((opt) => (
                            <Box key={opt.value} px={1}>
                                <FormControlLabel
                                control={
                                    <Checkbox size="small" color="primary"
                                    checked={forecastChecked.includes(opt.value)}
                                    onChange={(e) => {
                                        const updated = e.target.checked
                                        ? [...forecastChecked, opt.value]
                                        : forecastChecked.filter(v => v !== opt.value);
                                        setForecastChecked(updated);
                                        if (onRiskDaysChange) onRiskDaysChange(updated);
                                    }}
                                    style={{ padding: 4 }}
                                    />
                                }
                                label={<Typography style={{ fontFamily: 'Kanit', fontSize: 12 }}>{opt.label}</Typography>}
                                style={{ margin: 0 }}
                                />
                            </Box>
                            ))}
                        </Box>
                        )}
                    </Box>

                    {onDownload && (
                        <IconButton
                        onClick={() => {
                            const fileName = getFileName(forecastChecked);
                            onDownload(forecastChecked, fileName);
                        }}
                        title="ดาวน์โหลด"
                        style={{ padding: 4, flexShrink: 0 }}
                        >
                        <DownloadDocumentIcon />
                        </IconButton>
                    )}
                    </Box>
            </Box>

            <Divider
                style={{
                    marginTop: 20,
                    marginBottom: 20,
                    marginLeft: -16,
                    marginRight: -16,
                    backgroundColor: '#DBE5EC',
                    height: 1,
                }}
            />

            <Box mb={1}>
                <Typography
                    variant="h6"
                    style={{
                        fontFamily: 'Kanit',
                        fontWeight: 400,
                        color: '#7890A3',
                        fontSize: '13px',
                    }}
                >
                    {t('ตัวกรองพื้นที่')}
                </Typography>

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography
                        variant="h6"
                        style={{
                            fontFamily: 'Kanit',
                            fontWeight: 700,
                            fontSize: '15px',
                        }}
                        >
                        {t('ค้นหาพื้นที่เสี่ยง')}
                    </Typography>

                    <Button
                        size="small"
                        onClick={() => setSearch('')}
                        style={{
                            fontFamily: 'Kanit',
                            fontWeight: 400,
                            fontSize: '11px',
                            minWidth: 'auto',
                            padding: '4px 8px',
                            color: '#0878D1',
                            textTransform: 'none',
                        }}
                    >
                    ล้าง
                    </Button>
                </Box>
            </Box>

            <TextField
                fullWidth
                variant="outlined"
                placeholder="ตำบล อำเภอ จังหวัด"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                    startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon
                        style={{
                            color: '#9CA3AF',
                            transform: 'scaleX(-1)',
                            fontSize: 14,
                        }}
                        />
                    </InputAdornment>
                    ),
                    style: {
                        borderRadius: 9,
                        backgroundColor: '#FFFFFF',
                        height: 40,
                        fontFamily: 'Kanit',
                    },
                }}
            />

            {filtered.length > 0 && (
                <Box
                    style={{
                    border: '1px solid #DBE5EC',
                    borderRadius: 8,
                    marginTop: 4,
                    maxHeight: 200,
                    overflowY: 'auto',
                    backgroundColor: '#fff',
                    }}
                >
                    {filtered.map((d, i) => (
                    <Box
                        key={i}
                        px={2}
                        py={1}
                        style={{ cursor: 'pointer', borderBottom: '1px solid #f0f0f0' }}
                        onClick={() => {
                        const feature = geojsonTambon?.features?.find(f =>
                            f.properties.TAM_NAM_T?.includes(d.tumbon) &&
                            f.properties.AMPHOE_T?.includes(d.amphon)
                        );
                        if (feature && onStationSelect) {
                            const coords = feature.geometry?.coordinates;
                            const type = feature.geometry?.type;
                            let lat, lng;
                            if (type === 'Polygon') {
                            const ring = coords[0];
                            const lngSum = ring.reduce((s, c) => s + c[0], 0) / ring.length;
                            const latSum = ring.reduce((s, c) => s + c[1], 0) / ring.length;
                            lat = latSum;
                            lng = lngSum;
                            } else if (type === 'MultiPolygon') {
                            const ring = coords[0][0];
                            const lngSum = ring.reduce((s, c) => s + c[0], 0) / ring.length;
                            const latSum = ring.reduce((s, c) => s + c[1], 0) / ring.length;
                            lat = latSum;
                            lng = lngSum;
                            }
                            if (lat && lng) onStationSelect(lat, lng);
                        }
                        setSearch('');
                        }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <Typography style={{ fontFamily: 'Kanit', fontSize: 12, fontWeight: 500 }}>
                        {`ตำบล${d.tumbon ?? ''}`}
                        </Typography>
                        <Typography style={{ fontFamily: 'Kanit', fontSize: 10, color: '#6B7280' }}>
                        {`อ.${d.amphon ?? ''} จ.${d.provices ?? ''}`}
                        </Typography>
                        {/* <Typography style={{ fontFamily: 'Kanit', fontSize: 10, color: '#E80A05' }}>
                        {`FFPI: ${d.ffpi ?? '-'} | ฝน: ${d.accrf ?? '-'} มม.`}
                        </Typography> */}
                    </Box>
                    ))}
                </Box>
            )}

            <Divider
                style={{
                    marginTop: 20,
                    marginBottom: 20,
                    marginLeft: -16,
                    marginRight: -16,
                    backgroundColor: '#DBE5EC',
                    height: 1,
                }}
            />

            <Typography
                variant="h6"
                style={{ fontFamily: 'Kanit', fontWeight: 400, color: '#7890A3', fontSize: '13px'  }}
            >
                {t('ชั้นข้อมูล')}
            </Typography>
            <Typography
                variant="h6"
                style={{ fontFamily: 'Kanit', fontWeight: 700, marginBottom: 10, fontSize: '15px'  }}
            >
                {t('การแสดงผลบนแผนที่')}
            </Typography>
            
            <Box>
              <Box mb={2} mt={1}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box>
                    <Typography style={{ fontFamily: 'Kanit', fontWeight: 500, fontSize: 12 }}>ฝนตรวจวัด</Typography>
                    <Typography style={{ fontFamily: 'Kanit', fontWeight: 400, fontSize: 9, color: '#6B7280' }}>สถานีตรวจวัด</Typography>
                </Box>
                <Switch
                    checked={rainfallEnabled}
                    onChange={(checked) => setRainfallEnabled(checked)}
                    height={19} width={34} handleDiameter={13}
                    onColor="#2196F3" offColor="#D9D9D9"
                    checkedIcon={false} uncheckedIcon={false}
                />
                </Box>
                {rainfallEnabled && (
                <Box mt={1}>
                    <FormControl fullWidth variant="outlined" size="small">
                    <Select
                        value={forecastDay}
                        onChange={(e) => setForecastDay(e.target.value)}
                        style={{ height: 36, fontFamily: 'Kanit', fontSize: 14, borderRadius: 6 }}
                    >
                        <MenuItem value={1}>วานนี้</MenuItem>
                        <MenuItem value={2}>วันนี้</MenuItem>
                        <MenuItem value={3}>24 ชั่วโมง</MenuItem>
                        <MenuItem value={4}>3 วัน</MenuItem>
                        <MenuItem value={5}>7 วัน</MenuItem>
                        <MenuItem value={6}>15 วัน</MenuItem>
                        <MenuItem value={7}>30 วัน</MenuItem>
                    </Select>
                    </FormControl>
                </Box>
                )}

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={2}
                >
                    {/* Left */}
                    <Box>
                    <Typography
                        variant="subtitle1"
                        style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                    >
                        ฝนสะสม 5 วัน
                    </Typography>

                    <Typography
                        variant="body2"
                        color="textSecondary"
                        style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                    >
                        ฝนสะสมย้อนหลัง 5 วัน
                    </Typography>
                    </Box>

                    {/* Right */}
                    <Switch
                        checked={!!obsRainEnabled}
                        onChange={(checked) => {
                        if (setObsRainEnabled) setObsRainEnabled(checked);
                        }}
                        height={19}
                        width={34}
                        handleDiameter={13}
                        onColor="#2196F3"
                        offColor="#D9D9D9"
                        checkedIcon={false}
                        uncheckedIcon={false}
                    />
                </Box>

                {/* ฝนคาดการณ์ */}
                <Box mt={2}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                        <Typography style={{ fontFamily: 'Kanit', fontWeight: 500, fontSize: 12 }}>
                            ฝนคาดการณ์รายวัน
                        </Typography>
                        <Typography style={{ fontFamily: 'Kanit', fontWeight: 400, fontSize: 9, color: '#6B7280' }}>
                            ล่วงหน้า 1–6 วัน
                        </Typography>
                        </Box>
                        <Switch
                        checked={forecastRainEnabled}
                        onChange={(checked) => setForecastRainEnabled(checked)}
                        height={19} width={34} handleDiameter={13}
                        onColor="#2196F3" offColor="#D9D9D9"
                        checkedIcon={false} uncheckedIcon={false}
                        />
                    </Box>
                    {forecastRainEnabled && (
                        <Box mt={1}>
                        <FormControl fullWidth variant="outlined" size="small">
                            <Select
                            value={forecastRainDay}
                            onChange={(e) => setForecastRainDay(e.target.value)}
                            style={{ height: 36, fontFamily: 'Kanit', fontSize: 12 }}
                            >
                            {forecastOptions.map((item) => (
                                <MenuItem key={item.value} value={item.value} style={{ fontFamily: 'Kanit', fontSize: 12 }}>
                                {item.label}
                                </MenuItem>
                            ))}
                            </Select>
                        </FormControl>
                        </Box>
                    )}
                </Box>

                <Box mt={2}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box>
                            <Typography style={{ fontFamily: 'Kanit', fontWeight: 500, fontSize: 12 }}>
                                ฝนสะสมคาดการณ์
                            </Typography>
                            <Typography style={{ fontFamily: 'Kanit', fontWeight: 400, fontSize: 9, color: '#6B7280' }}>
                                ฝนสะสมคาดการณ์ 3 วัน 5 วัน 7 วัน
                            </Typography>
                        </Box>
                        <Switch
                            checked={forecastAccumEnabled}
                            onChange={(checked) => setForecastAccumEnabled(checked)}
                            height={19} width={34} handleDiameter={13}
                            onColor="#2196F3" offColor="#D9D9D9"
                            checkedIcon={false} uncheckedIcon={false}
                        />
                    </Box>

                    {forecastAccumEnabled && (
                        <Box mt={1}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <Select
                                    value={forecastAccumDay}
                                    onChange={(e) => setForecastAccumDay(e.target.value)}
                                    style={{ height: 36, fontFamily: 'Kanit', fontSize: 12 }}
                                >
                                    {accumOptions.map((item) => (
                                        <MenuItem
                                            key={item.value}
                                            value={item.value}
                                            style={{ fontFamily: 'Kanit', fontSize: 12 }}
                                        >
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    )}
                </Box>
            </Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
            >
                {/* Left */}
                <Box>
                <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                >
                    ดัชนีศักยภาพการเกิดน้ำท่วมฉับพลัน (FFPI)
                </Typography>

                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                >
                    ความไวต่อการเกิดน้ำหลาก
                </Typography>
                </Box>

                {/* Right */}
                <Switch
                    checked={ffpiEnabled}
                    onChange={(checked) => {
                    if (onFfpiToggle) onFfpiToggle(checked);
                    }}
                    height={19}
                    width={34}
                    handleDiameter={13}
                    onColor="#2196F3"
                    offColor="#D9D9D9"
                    checkedIcon={false}
                    uncheckedIcon={false}
                />
            </Box>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
            >
                {/* Left */}
                <Box>
                <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                >
                    ติดตามพายุ
                </Typography>

                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                >
                    พายุเข้าใกล้ประเทศไทย
                </Typography>
                </Box>

                {/* Right */}
                <Switch
                    checked={stormEnabled}
                      onChange={(checked) => {
                        setStormEnabled(checked);
                        if (onStormToggle) onStormToggle(checked); // เพิ่ม
                        }}
                    height={19}
                    width={34}
                    handleDiameter={13}
                    onColor="#2196F3"
                    offColor="#D9D9D9"
                    checkedIcon={false}
                    uncheckedIcon={false}
                />
            </Box>

            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mt={2}
            >
                {/* Left */}
                <Box>
                <Typography
                    variant="subtitle1"
                    style={{ fontWeight: 500, fontFamily: 'Kanit', fontSize: '12px' }}
                >
                    เส้นแม่น้ำ
                </Typography>

                <Typography
                    variant="body2"
                    color="textSecondary"
                    style={{ fontWeight: 400, fontFamily: 'Kanit', fontSize: '9px' }}
                >
                    โครงข่ายลำน้ำ
                </Typography>
                </Box>

                {/* Right */}
                <Switch
                    checked={riverEnabled}
                    onChange={(checked) => {
                        setRiverEnabled(checked);
                        if (onRiverToggle) onRiverToggle(checked);
                    }}
                    height={19}
                    width={34}
                    handleDiameter={13}
                    onColor="#2196F3"
                    offColor="#D9D9D9"
                    checkedIcon={false}
                    uncheckedIcon={false}
                />
            </Box>

            {/* <Box mt={1}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    style={{
                    cursor: "pointer",
                    padding: "8px 0",
                    }}
                    onClick={() => setOpenRiver(!openRiver)}
                >
                    <Box>
                    <Typography
                        style={{
                        fontFamily: "Kanit",
                        fontWeight: 500,
                        fontSize: 12,
                        }}
                    >
                        เส้นลำน้ำ
                    </Typography>

                    <Typography
                        style={{
                        fontFamily: "Kanit",
                        fontWeight: 400,
                        fontSize: 9,
                        color: "#7890A3",
                        }}
                    >
                        โครงข่ายลำน้ำอ้างอิง
                    </Typography>
                    </Box>

                    <IconButton size="small">
                    {openRiver ? (
                        <KeyboardArrowDownIcon />
                    ) : (
                        <KeyboardArrowRightIcon />
                    )}
                    </IconButton>
                </Box>

                <Collapse in={openRiver}>
                <Box ml={1}>
                    <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    >
                    <Typography
                        style={{
                        fontFamily: "Kanit",
                        fontSize: 12,
                        }}
                    >
                        • เส้นลำน้ำหลัก
                    </Typography>

                    <Checkbox
                        checked={mainRiver}
                        onChange={(e) => {
                            setMainRiver(e.target.checked);
                            if (onMainRiverToggle) onMainRiverToggle(e.target.checked); // เพิ่ม
                        }}
                        color="primary"
                        size="small"
                    />
                    </Box>

                    <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    >
                    <Typography
                        style={{
                        fontFamily: "Kanit",
                        fontSize: 12,
                        }}
                    >
                        • เส้นลำน้ำรอง
                    </Typography>

                    <Checkbox
                        checked={secoundRiver}
                        onChange={(e) => {
                            setsecoundRiver(e.target.checked);
                            if (onSecoundRiverToggle) onSecoundRiverToggle(e.target.checked);
                        }}
                        color="primary"
                        size="small"
                    />
                    </Box>
                </Box>
                </Collapse>
            </Box> */}
            
            <Box mt={1}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    style={{
                    cursor: "pointer",
                    padding: "8px 0",
                    }}
                    onClick={() => setOpenBoundary(!openBoundary)}
                >
                    <Box>
                    <Typography
                        style={{
                        fontFamily: "Kanit",
                        fontWeight: 500,
                        fontSize: 12,
                        }}
                    >
                        ขอบเขตการปกครอง
                    </Typography>

                    <Typography
                        style={{
                        fontFamily: "Kanit",
                        fontWeight: 400,
                        fontSize: 9,
                        color: "#7890A3",
                        }}
                    >
                        ขอบเขตการปกครอง
                    </Typography>
                    </Box>

                    <IconButton size="small">
                    {openBoundary ? (
                        <KeyboardArrowDownIcon />
                    ) : (
                        <KeyboardArrowRightIcon />
                    )}
                    </IconButton>
                </Box>

                <Collapse in={openBoundary}>
                <Box ml={1}>
                    <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    >
                    <Typography
                        style={{
                        fontFamily: "Kanit",
                        fontSize: 12,
                        }}
                    >
                        • ขอบเขตจังหวัด
                    </Typography>

                    <Checkbox
                        checked={provinceBoundary}
                        onChange={(e) => {
                            setProvinceBoundary(e.target.checked);
                            if (onProvinceBoundaryToggle) onProvinceBoundaryToggle(e.target.checked);
                        }}
                        color="primary"
                        size="small"
                    />
                    </Box>

                    <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    >
                    <Typography
                        style={{
                        fontFamily: "Kanit",
                        fontSize: 12,
                        }}
                    >
                        • ขอบเขตอำเภอ
                    </Typography>
                        <Checkbox
                        checked={amphoeBoundary}
                        onChange={(e) => {
                            setAmphoeBoundary(e.target.checked);
                            if (onAmphoeBoundaryToggle) onAmphoeBoundaryToggle(e.target.checked);
                        }}
                        color="primary"
                        size="small"
                    />
                    </Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography style={{ fontFamily: "Kanit", fontSize: 12 }}>
                            • ขอบเขตตำบล
                        </Typography>
                        <Checkbox
                            checked={tambonBoundary}
                            onChange={(e) => {
                            setTambonBoundary(e.target.checked);
                            if (onTambonBoundaryToggle) onTambonBoundaryToggle(e.target.checked);
                            }}
                            color="primary"
                            size="small"
                        />
                    </Box>
                </Box>
                </Collapse>
            </Box>

            </Box>

            {/* <Button
                fullWidth
                variant="contained"
                style={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #BBCEDAE5',
                boxShadow: 'none',
                textTransform: 'none',
                fontFamily: 'Kanit',
                justifyContent: 'flex-start',
                marginBottom: 8,
                }}
                startIcon={<FormatListBulletedIcon />}
                onClick={() => onOpenReport(datasNhc, header)}
            >
                {t('รายละเอียดพื้นที่เสี่ยง')}
            </Button> */}
        </Box>
    </div>
    );
}

FlashFloodSidebar.propTypes = {
  header: PropTypes.array.isRequired,
  datasNhc: PropTypes.array.isRequired,
  onOpenReport: PropTypes.func.isRequired,
  onFcstRainToggle: PropTypes.func,
  onMainRiverToggle: PropTypes.func,
  onSecoundRiverToggle: PropTypes.func,
  rainfallEnabled: PropTypes.bool,
  setRainfallEnabled: PropTypes.func,
  forecastDay: PropTypes.number,
  setForecastDay: PropTypes.func,
  forecastRainEnabled: PropTypes.bool,
  setForecastRainEnabled: PropTypes.func,
  forecastRainDay: PropTypes.number,
  setForecastRainDay: PropTypes.func,
  forecastOptions: PropTypes.array,
  onStormToggle: PropTypes.func,
  onRiskAreaToggle: PropTypes.func,
  onRiverToggle: PropTypes.func,
  geojsonTambon: PropTypes.object,
  onStationSelect: PropTypes.func,
  ffpiEnabled: PropTypes.bool,
  onFfpiToggle: PropTypes.func,
  onRiskDaysChange: PropTypes.func,
  onForecastAccumChange: PropTypes.func,
  onDownload: PropTypes.func,
  accumOptions: PropTypes.array,
  forecastAccumEnabled: PropTypes.bool,
  setForecastAccumEnabled: PropTypes.func,
  forecastAccumDay: PropTypes.string,
  setForecastAccumDay: PropTypes.func,
  obsRainEnabled: PropTypes.bool,
  setObsRainEnabled: PropTypes.func,
};